import {useContext} from 'react'

import Context from '@s-ui/react-context'
import PanelCardGroup, {panelCardGroupImageSizes} from '@adv-mt/mt-panel-card-group'

const BASE_CLASS_NAME = 'mt-Landing-InstantOffer-CardsBenefits'

const LandingInstantOfferCardBenefits = () => {
  const {domain, i18n} = useContext(Context)
  const config = domain.get('config')
  const URL_STATICS_IMAGES = config.get('URL_STATICS_IMAGES')

  const cards = [
    {
      title: 'Vende y despreocúpate',
      description: 'Una vez vendido el coche la garantía es responsabilidad del profesional.',
      image: {
        alt: 'Vende y despreocúpate',
        src: `${URL_STATICS_IMAGES}pictograms/Coffee.svg`
      }
    },

    {
      title: 'Olvídate de los trámites',
      description: 'El profesional se ocupa de todo el papeleo de compra-venta, y también del coste.',
      image: {
        alt: 'Olvídate de los trámites',
        src: `${URL_STATICS_IMAGES}pictograms/NoPapers.svg`
      }
    },
    {
      title: 'Seguridad en el pago',
      description: 'Recibe el importe al momento y con total transparencia y confianza.',
      image: {
        alt: 'Seguridad en el pago',
        src: `${URL_STATICS_IMAGES}pictograms/PackHandMoney.svg`
      }
    }
  ]

  return (
    <div className={BASE_CLASS_NAME}>
      <PanelCardGroup
        cardImageSize={panelCardGroupImageSizes.s}
        cards={cards}
        title={i18n.t('INSTANT_OFFER.LANDING.BENEFITS.TITLE')}
        description={'Te lo ponemos muy fácil para vender tu vehículo a un profesional de confianza.'}
      />
    </div>
  )
}

LandingInstantOfferCardBenefits.displayName = 'LandingInstantOfferCardBenefits'

export default LandingInstantOfferCardBenefits
